
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import { Prop, Watch } from "vue-property-decorator";
import Cropper from "vue-image-crop-upload";

@Component({
  components: {
    Cropper,
  },
  filters,
})
export default class ImageCropper extends Vue {
  @Prop({ default: false })
  private show!: any;
  @Prop({ default: 1366 })
  private width!: any;
  @Prop({ default: 768 })
  private height!: any;
  @Prop({ default: "" })
  private data!: string;

  private value = false;

  @Watch("show")
  private onTrigger() {
    this.value = this.show;
  }
  @Watch("value")
  private onClose() {
    if (!this.value) this.$emit("close");
  }

  private data2blob(data: string, mime: string) {
    data = data.split(",")[1];
    data = window.atob(data);
    const ia = new Uint8Array(data.length);
    for (let i = 0; i < data.length; i++) ia[i] = data.charCodeAt(i);
    return new Blob([ia], {
      type: mime,
    });
  }

  private onCropSuccess(imgUrl: any) {
    const imageCrop = this.$refs.imageCrop as any;
    const blobFile = this.data2blob(imgUrl, imageCrop.mime as string);
    const fileName = `${Date.now().toString()}-cropped-image.${
      imageCrop.imgFormat
    }`;
    imageCrop.setStep(1);
    const file = new File([blobFile], fileName);
    this.$emit("update:data", file);
    this.$emit("change", file);
    this.$emit("close");
  }
}
